module.exports = __webpack_public_path__ + "static/compSec-71bbcd132a5110d1414bc9d83e574fef.jpg";